import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * SPA route-change hygiene: scroll to the top and move focus to the main
 * landmark so keyboard and screen-reader users land at the new page's
 * content instead of wherever focus was left.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
    const main = document.getElementById('main');
    if (main) main.focus({ preventScroll: true });
  }, [pathname]);

  return null;
}
